import { ANIMATION_TIMEOUT, MODAL_ELEMENT_ID } from '@/components/ModalWindow/ModalWindow';
import { ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import FocusLock from 'react-focus-lock';
import { ModalContainer, ModalOverlay, ModalWrapper } from '@/components/ModalWindow/styles';
import { ModalContent } from './styles';

type CookiesManagePreferencesModalWindowType = {
  isOpen: boolean;
  children: ReactNode;
};

export const CookiesManagePreferencesModalWindow = ({ isOpen, children }: CookiesManagePreferencesModalWindowType) => {
  const nodeRef = useRef(null);

  return createPortal(
    <CSSTransition
      in={isOpen}
      nodeRef={nodeRef}
      timeout={{ enter: ANIMATION_TIMEOUT, exit: 0 }}
      classNames='fade'
      unmountOnExit
    >
      <FocusLock>
        <ModalWrapper>
          <ModalOverlay />
          <ModalContainer>
            <ModalContent>{children}</ModalContent>
          </ModalContainer>
        </ModalWrapper>
      </FocusLock>
    </CSSTransition>,
    document.getElementById(MODAL_ELEMENT_ID)
  );
};
